import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLevel = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 10,
	viewBox: "0 0 15 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M0.714355 6.42857C0.714355 5.63959 1.35395 5 2.14293 5C2.93191 5 3.5715 5.63959 3.5715 6.42857V8.57143C3.5715 9.36041 2.93191 10 2.14293 10C1.35395 10 0.714355 9.36041 0.714355 8.57143V6.42857Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.42871 3.57115C6.42871 2.78217 7.0683 2.14258 7.85728 2.14258C8.64626 2.14258 9.28585 2.78217 9.28585 3.57115V8.57115C9.28585 9.36013 8.64626 9.99972 7.85728 9.99972C7.0683 9.99972 6.42871 9.36013 6.42871 8.57115V3.57115Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.1431 1.42857C12.1431 0.639593 12.7827 0 13.5716 0C14.3606 0 15.0002 0.639593 15.0002 1.42857V8.57143C15.0002 9.36041 14.3606 10 13.5716 10C12.7827 10 12.1431 9.36041 12.1431 8.57143V1.42857Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgLevel);
export { ForwardRef as ReactComponent };
